export type StepName =
  | 'goalDescription'
  | 'goalType'
  | 'budget'
  | 'accounts'
  | 'targetDate'
  | 'review';

export const LARGE_PURCHASE_GOAL_STEPS: StepName[] = [
  'goalDescription',
  'goalType',
  'budget',
  'accounts',
  'review',
];

export const EXPENSE_GOAL_STEPS: StepName[] = ['goalDescription', 'goalType', 'budget', 'review'];

export const NON_FINANCIAL_GOAL_STEPS: StepName[] = ['goalDescription', 'targetDate', 'review'];

export const FORM_ID = 'set-goal-step-form';
